const homePage: Record<string, Record<string, string>> = {
    headerLinks: {
        requests: 'My applications',
        requestsNew: 'Applications',
        campaigns: 'Competitions',
    },
};

export default homePage;